import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  result: {},
  line: {},
};

export const calculateSlice = createSlice({
  name: "calc",
  initialState,
  reducers: {
    calcFabrick: (state, action) => {
      const { data } = action.payload;
      let dayLine = [];
      let heightLine = [];

      let totalHeightDay = 0;
      let totalHeightWeek = 0;
      let totalHeightMonth = 0;
      let lineHeightDay = 0;
      const currentDate = new Date();
      const currentMonth = currentDate.getMonth() + 1;
      let sortedFolderDate = [...data];
      sortedFolderDate.sort((a, b) => {
        let [dayA, monthA] = a.date.includes('.') ? a.date.split('.').map(Number) : a.date.split(',').map(Number);
        let [dayB, monthB] = b.date.includes('.') ? b.date.split('.').map(Number) : b.date.split(',').map(Number);
        
        let dateA = new Date(2024, monthA - 1, dayA);
        let dateB = new Date(2024, monthB - 1, dayB);

        return dateA - dateB;
    })
      
      sortedFolderDate.forEach((folder) => {
            const [day, month] = folder.date.split(".");
            
            folder.item.forEach((item) => {
              const height = parseInt(item.height);
              const col = parseInt(item.col);
              lineHeightDay += height * col;
              if (
                parseInt(day) === currentDate.getDate() &&
                parseInt(month) === currentDate.getMonth() + 1
              ) {
                totalHeightDay += height * col;
              }

              if (
                parseInt(day) >=
                  currentDate.getDate() - currentDate.getDay() + 1 &&
                parseInt(month) === currentDate.getMonth() + 1
              ) {
                totalHeightWeek += height * col;
              }

              if (parseInt(month) === currentMonth) {
                totalHeightMonth += height * col;
              }
            });
            dayLine.push(folder.date);
            heightLine.push(lineHeightDay);
            lineHeightDay=0
          });
        
     
      state.line = {
        day: dayLine,
        height: heightLine,
      };
      state.result = {
        totalHeightDay,
        totalHeightWeek,
        totalHeightMonth,
      };
    },
  },
});

export default calculateSlice.reducer;
export const { calcFabrick } = calculateSlice.actions;
